<template>
  <Field as="fieldset" :width="width">
    <Checkbox
      v-bind="$attrs"
      :class="{ error }"
    >
      <template v-for="(value, key) in $slots" v-slot:[key]>
        <slot :name="key" />
      </template>
    </Checkbox>
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </Field>
</template>

<script>
import Checkbox from 'Web/Form/Inputs/Checkbox.vue';
import Field from 'Web/Form/Fields/Field.vue';

export default {
  inheritAttrs: false,
  components: {
    Field,
    Checkbox,
  },
  props: {
    error: String,
    width: String,
  },
  setup: Checkbox.setup
}
</script>
